var render = function render(){var _vm=this,_c=_vm._self._c;return _c('StandartModule',{attrs:{"data":_vm.data,"loading":_vm.loading,"error":_vm.error}})
}
var staticRenderFns = []

export { render, staticRenderFns }